import { isSaasAdmin } from '@crm/shared';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/modules/auth/hooks';
import { DashboardPage } from '@/modules/auth/pages';
import { SAAS_ROUTES } from '@/modules/saas/api';
import { SIGNUP_ROUTES } from '@/modules/signup';

/**
 * A raiz do sistema. Nem todo perfil comeca no painel: o atendimento cai na
 * agenda e o financeiro, nas contas a pagar. Quem nao tem pagina propria - ou
 * cujo perfil aponta para a propria raiz - fica no painel mesmo.
 */
export function HomeRoute() {
  const { user } = useSession();

  // Quem administra o SaaS nao tem empresa: o painel do salao so lhe renderia
  // uma tela de erros 403, entao a raiz dele e a lista de assinantes.
  if (isSaasAdmin(user)) return <Navigate to={SAAS_ROUTES.SUBSCRIBERS} replace />;

  // Abandonou o wizard guiado da jornada antes do ultimo passo: ao logar de
  // novo, volta direto para o wizard cheio - nao para o painel com o guia
  // compacto. Os passos que o sistema fecha sozinho (WhatsApp, campanha)
  // nunca chegam aqui - user.journeyStep so traz os quatro guiados.
  if (user?.journeyStep) return <Navigate to={SIGNUP_ROUTES.WIZARD} replace />;

  // Terminou o cadastro com a fila de espera ligada: cai direto na tela de
  // fila, nao no painel, ate o time liberar o acesso na mao.
  if (user?.onWaitlist) return <Navigate to={SIGNUP_ROUTES.WAITLIST} replace />;

  const destino = user?.homeRoute;

  if (destino && destino !== '/') return <Navigate to={destino} replace />;

  return <DashboardPage />;
}
